import React from 'react';

import { Box, Grid, Typography, Divider } from '@mui/material';

import { paymentsSummaryStyles } from 'components/Invoice/styles/styles';
import { Button } from 'shared';

const PaymentsSummary = ({ data, buttonLoader, handleFilterResultsClick }) => {
    const {
        adjustments = 0,
        deposit_amount = 0,
        needs_attention = 0,
        total_transactions = 0,
        adjustments_amount = 0,
    } = data;

    const classes = paymentsSummaryStyles();

    const StatBox = ({ label, value, isCurrency }) => (
        <Box sx={classes.statbox}>
            <Typography sx={classes.statBoxTitle}>
                {isCurrency ? `$${Number(value).toLocaleString()}` : value}
            </Typography>
            <Typography variant="caption" sx={classes.statBoxLabel}>
                {label}
            </Typography>
        </Box>
    );

    return (
        <Box sx={classes.root}>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={10}>
                    <Box display="flex" justifyContent="space-between" flexWrap="wrap">
                        <StatBox label="Total Transactions" value={total_transactions} />
                        <StatBox label="Deposit Amount" value={deposit_amount} isCurrency />
                        <StatBox label="Adjustments" value={adjustments} />
                        <StatBox label="Adjustments Amount" value={adjustments_amount} isCurrency />
                        <StatBox label="Needs Attention" value={needs_attention} />
                    </Box>
                </Grid>

                <Grid item xs={0.2} sx={classes.dividerWrapper}>
                    <Divider orientation="vertical" flexItem sx={classes.divider} />
                </Grid>

                <Grid item xs={1.5}>
                    <Box sx={classes.buttonWrapper}>
                        <Button
                            size="small"
                            variant="contained"
                            sx={classes.button}
                            onClick={handleFilterResultsClick}
                            loading={buttonLoader}
                            text="Filter Results"
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default PaymentsSummary;
